// src/pages/AdminPage.js
import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import AdminLogin from '../components/AdminLogin';
import AdminDashboard from '../components/AdminDashboard';

const AdminPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        background: '#f3f4f6'
      }}>
        <div style={{ fontSize: '1.2rem', color: '#6b7280' }}>
          Loading...
        </div>
      </div>
    );
  }

  return user ? <AdminDashboard /> : <AdminLogin onLoginSuccess={() => setUser(auth.currentUser)} />;
};

export default AdminPage;
